import { MutableRefObject, useState } from 'react';
import { FocusedPlace, Board, SidebarMode, StickerDesignId, SlapId, ObjectiveId } from '../utils/Primitives';
import LatestSlaps from '../slaps/LatestSlaps';
import ObjectivesComingSoon from './ObjectivesComingSoon';
import FocusedPlaceDetails from './FocusedPlaceDetails'

export default function GameSidebar(props: {
    boardRef: MutableRefObject<Board>;
    focusedPlace: FocusedPlace;
    setFocusOnPlace: (item: FocusedPlace) => void;
    handleReviewStickerId: (stickerId: StickerDesignId) => void;
    handleReviewSlapId: (slapId: SlapId) => void;
    activeSidebarMode: SidebarMode | null;
    setActiveSidebarMode: (mode: SidebarMode | null) => void;
    focusedObjectiveId: ObjectiveId | null;
    setFocusedObjectiveId: (objectiveId: ObjectiveId | null) => void;
    handleSlapCreatorOpen: () => void;
}) {
    const {
        boardRef,
        focusedPlace,
        setFocusOnPlace,
        handleReviewStickerId,
        handleReviewSlapId,
        activeSidebarMode,
        setActiveSidebarMode,
        focusedObjectiveId,
        setFocusedObjectiveId,
        handleSlapCreatorOpen
    } = props;
    const states = Object.values(SidebarMode)
        .filter((state) => state !== SidebarMode.Objectives);

    const [latestSlapsCurrentPage, setLatestSlapsCurrentPage] = useState(1);
    const [objectivesCurrentPage, setObjectivesCurrentPage] = useState<{ [key: number]: number }>({});

    const focusState = (state: SidebarMode) => {
        setActiveSidebarMode(state);
    };

    const apiUrl = process.env.NEXT_PUBLIC_STICKERCLOUD_API;
    const fetchUrl = apiUrl ? `${apiUrl}slaps` : '';

    const updateObjectivePage = (objectiveId: number, page: number) => {
        setObjectivesCurrentPage((prev) => ({
            ...prev,
            [objectiveId]: page,
        }));
    };

    const handleObjectivePageUpdate = (objectiveId: number, page: number) => {
        updateObjectivePage(objectiveId, page);
    };

    const handleStickerClick = (stickerId: StickerDesignId, e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        handleReviewStickerId(stickerId);
    };

    const handleSlapClick = (slapId: SlapId, e: React.MouseEvent<HTMLDivElement>) => {
        e.preventDefault();
        handleReviewSlapId(slapId);
    };


    return (
        <div className='w-full mt-4 md:text-lg px-3 pt-4 pb-4 border-2 border-gray-300 rounded bg-gray-200 text-slate-900'>
            <div className='font-sans mt-1 flex flex-wrap gap-2 justify-center'>
                {states.map((state) => (
                    <button
                        key={state}
                        onClick={() => focusState(state)}
                        className={`
                            px-3 py-1 rounded-full text-xs transition-colors duration-200
                            ${activeSidebarMode === state
                                ? 'bg-white text-blue-600 font-semibold'
                                : 'bg-white text-slate-700 font-medium hover:bg-gray-300'
                            }
                        `}
                    >
                        {state}
                    </button>
                ))}
            </div>

            {activeSidebarMode === SidebarMode.Latest && (
                <LatestSlaps
                    boardRef={boardRef}
                    fetchUrl={fetchUrl}
                    slapsPerPage={5}
                    setFocusOnPlace={setFocusOnPlace}
                    handleStickerClick={handleStickerClick}
                    handleSlapClick={handleSlapClick}
                    currentPage={latestSlapsCurrentPage}
                    setCurrentPage={setLatestSlapsCurrentPage}
                />
            )}

            {activeSidebarMode === SidebarMode.Place && (
                <FocusedPlaceDetails
                    focusedPlace={focusedPlace}
                    boardRef={boardRef}
                    setFocusOnPlace={setFocusOnPlace}
                    currentPage={latestSlapsCurrentPage}
                    setCurrentPage={setLatestSlapsCurrentPage}
                    handleSlapClick={handleSlapClick}
                    handleStickerClick={handleStickerClick}
                    handleSlapCreatorOpen={handleSlapCreatorOpen}
                />
            )}

            {activeSidebarMode === SidebarMode.Objectives && (
                <ObjectivesComingSoon />
            )}

        </div>
    );
}
